import PropTypes from 'prop-types';
import React from 'react';

import {
  StyledTable,
  StyledTbody,
  StyledTd,
  StyledTh,
  StyledThead,
  StyledTheadTr,
  StyledTr,
} from './styles';

export const Table = ({ children, className, ...props }) => (
  <StyledTable className={className} {...props}>
    {children}
  </StyledTable>
);

Table.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Table.defaultProps = {
  children: undefined,
  className: undefined,
};

export const Thead = ({ children, className, ...props }) => (
  <StyledThead className={className} {...props}>
    {children}
  </StyledThead>
);

Thead.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Thead.defaultProps = {
  children: undefined,
  className: undefined,
};

export const TheadTr = ({ children, className, ...props }) => (
  <StyledTheadTr className={className} {...props}>
    {children}
  </StyledTheadTr>
);

TheadTr.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

TheadTr.defaultProps = {
  children: undefined,
  className: undefined,
};

export const Th = ({ children, className, ...props }) => (
  <StyledTh className={className} {...props}>
    {children}
  </StyledTh>
);

Th.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Th.defaultProps = {
  children: undefined,
  className: undefined,
};

export const Tbody = ({ children, className, ...props }) => (
  <StyledTbody className={className} {...props}>
    {children}
  </StyledTbody>
);

Tbody.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Tbody.defaultProps = {
  children: undefined,
  className: undefined,
};

export const Tr = ({ children, className, ...props }) => (
  <StyledTr className={className} {...props}>
    {children}
  </StyledTr>
);

Tr.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Tr.defaultProps = {
  children: undefined,
  className: undefined,
};

export const Td = ({ width, children, className, ...props }) => (
  <StyledTd className={className} width={width} {...props}>
    {children}
  </StyledTd>
);

Td.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Td.defaultProps = {
  children: undefined,
  className: undefined,
  width: undefined,
};
